// Pływający przycisk menu na telefonie (components/sidebar.js#MobileToggleFab).
//
// Przycisk stoi na stałe w lewym górnym rogu, a treść ma nad sobą tylko 64px zapasu (App.js
// #MainContent), więc po przewinięciu półprzezroczysty przycisk leżał na tekście: z licznika
// „64 szt.” w Magazynie widać było „4 szt.”, a w planie dnia zasłaniał plakietkę daty (test na
// iPhonie 17, 18.10.2026). Teraz przy przewijaniu W DÓŁ przycisk się chowa (czytanie i przeglądanie
// listy), przy przewijaniu W GÓRĘ wraca (ktoś szuka nawigacji), a na samej górze strony jest zawsze.
// Gdy wraca w środku strony, ma pełne tło, więc nie miesza się z tekstem pod spodem.

// Wysokość zapasu nad treścią na telefonie (App.js#MainContent, padding-top 64px).
export const ZAPAS_NAD_TRESCIA = 64;
// Drobne drgnięcia (bezwładność przewijania na iOS, odbicie na końcu strony) niczego nie zmieniają.
export const HISTEREZA = 8;

/**
 * Stan przycisku po przewinięciu do `top` (px od góry kontenera przewijania). `kotwica` to
 * położenie, przy którym stan zmienił się ostatnio: kierunek liczy się od niej, nie od
 * poprzedniego zdarzenia, bo powolne przewijanie palcem daje zdarzenia co 1-2px.
 * Zwraca `{ ukryty, nadTrescia, kotwica }`; `nadTrescia` = przycisk stoi nad przewiniętą treścią.
 */
export function stanPrzyciskuMenu({ kotwica = 0, top = 0, ukryty = false } = {}) {
  const t = Math.max(0, Number(top) || 0);
  const k = Math.max(0, Number(kotwica) || 0);
  if (t <= ZAPAS_NAD_TRESCIA) return { ukryty: false, nadTrescia: false, kotwica: t };
  if (t - k > HISTEREZA) return { ukryty: true, nadTrescia: true, kotwica: t };
  if (k - t > HISTEREZA) return { ukryty: false, nadTrescia: true, kotwica: t };
  // Ruch w tym samym kierunku co ostatnia decyzja przesuwa kotwicę, żeby powrót liczył się od
  // miejsca, w którym ktoś zmienił kierunek.
  const dalejWTymSamym = ukryty ? t > k : t < k;
  return { ukryty, nadTrescia: true, kotwica: dalejWTymSamym ? t : k };
}
